export default __webpack_public_path__ + "static/media/previewImg.eaf0b140.jpg";